var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3999 6.00039C8.3999 5.04561 8.77919 4.12994 9.45432 3.45481C10.1294 2.77968 11.0451 2.40039 11.9999 2.40039C12.9547 2.40039 13.8704 2.77968 14.5455 3.45481C15.2206 4.12994 15.5999 5.04561 15.5999 6.00039M8.3999 6.00039H15.5999M8.3999 6.00039H4.7999M15.5999 6.00039H19.1999M4.7999 6.00039H2.3999M4.7999 6.00039V19.2004C4.7999 19.8369 5.05276 20.4474 5.50285 20.8974C5.95293 21.3475 6.56338 21.6004 7.1999 21.6004H16.7999C17.4364 21.6004 18.0469 21.3475 18.497 20.8974C18.947 20.4474 19.1999 19.8369 19.1999 19.2004V6.00039M19.1999 6.00039H21.5999",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d195b28c1d0cfc3e10a6c3c4c6980cc1.svg";
export { ForwardRef as ReactComponent };